import { type RecordId } from '../types';
import {
  type SerializedField,
  commonSerializedKeys,
  type FieldType,
  type BaseSerializedField,
} from '.';
import type DataStoreFields from '../collaboration/DataStoreFields';
import DataStoreRecordBehaviors, {
  type IDataStoreRecordBehaviors,
} from '../collaboration/DataStoreRecordBehaviors';

class BaseField<T = string>
  extends DataStoreRecordBehaviors(Object)
  implements BaseSerializedField
{
  serializedKeys = commonSerializedKeys;
  id: RecordId;
  type: FieldType;
  name: string;
  internal: boolean;

  _dataStore: DataStoreFields;

  constructor(attributes: Partial<SerializedField> = {}) {
    super();

    Object.assign(this, attributes);
  }

  get valueKey() {
    return `field_value_${this.id}`;
  }

  valueForObject(object: IDataStoreRecordBehaviors): T | undefined {
    return object[this.valueKey];
  }

  setValueForObject(object: IDataStoreRecordBehaviors, value: T) {
    object.set(this.valueKey, value);
  }
}

export default BaseField;
